// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"6589a104","477":"3f3eadf2","513":"73561fd3","787":"3986d368"}[chunkId] + ".chunk.js";
};